import axios from "axios";
import {appConfig} from "./appConfig";

export const axiosInstance = axios.create({
  baseURL: `https://api.${appConfig.domain}`,
  withCredentials: true
});
